import { MaintenanceForwardingsDirectiveEntryKlass } from "../types/maintenanceForwardingsDirectiveEntryKlasses.type";
import { MaintenanceForwardingsDirectiveFromSteps } from "../types/maintenanceForwardingsShowDirectiveDetails.type";

export const directiveEntriesAdditionalDirectiveSteps: Partial<{
  [K in MaintenanceForwardingsDirectiveEntryKlass]: {
    beforeRequiredDirectiveSteps: MaintenanceForwardingsDirectiveFromSteps[];
    afterRequiredDirectiveSteps: MaintenanceForwardingsDirectiveFromSteps[];
  }
}> = {
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: {
    beforeRequiredDirectiveSteps: [
      MaintenanceForwardingsDirectiveFromSteps.DirectiveComplexity,
    ],
    afterRequiredDirectiveSteps: [],
  },
}
